import { BarItemProps, ResponsiveBar } from "@nivo/bar";

import { InvestmentGraphic } from "components/InvestmentGraphicNew";

import styles from "./LoanProfitChart.module.scss";

const CustomBar = (props: BarItemProps<any>) => {
  const { bar, borderRadius = 2 } = props;

  return (
    <g transform={`translate(${bar.x}, ${bar.y})`}>
      <rect
        width={bar.width}
        height={bar.height}
        rx={borderRadius}
        ry={borderRadius}
        fill={bar.color}
      />
      <text
        x={bar.width / 2}
        y={-10}
        textAnchor="middle"
        dominantBaseline="central"
        style={{
          fontFamily: "Reddit Sans",
          pointerEvents: "none",
          fontSize: 8,
          fontWeight: 500,
        }}
        fill={"#000"}
      >
        {bar.data.data.chartItem}
      </text>
    </g>
  );
};

const LoanProfitChart = ({
  variant,
  title,
  price,
  description,
  descriptionVariant,
  caption,
  details,
  data,
  labelTextColor,
  infoPopover,
}: {
  variant: string;
  descriptionVariant?: string;
  title: string;
  price: string;
  description: React.ReactNode;
  caption: string;
  details: string;
  data: any;
  labelTextColor: string;
  infoPopover?: React.ReactNode;
}) => {
  return (
    <InvestmentGraphic
      variant={variant}
      title={title}
      price={price}
      caption={caption}
      description={description}
      descriptionVariant={descriptionVariant}
      details={details}
      infoPopover={infoPopover}
    >
      <div className={styles.chart}>
        <ResponsiveBar
          data={data}
          indexBy="chartItem"
          enableLabel
          enableGridY={false}
          labelSkipWidth={12}
          labelSkipHeight={12}
          axisBottom={null}
          axisLeft={null}
          colors={({ id, data }) => {
            return String(data[`${id}Color`]);
          }}
          labelPosition="end"
          labelOffset={10}
          labelTextColor={labelTextColor}
          label={(labelItem: any) => {
            return labelItem.data.chartItem;
          }}
          barComponent={CustomBar}
          tooltip={() => <></>}
          margin={{ top: 15, right: 0, bottom: 0, left: 0 }}
          theme={{
            labels: {
              text: {
                fontSize: 8,
              },
            },
          }}
        />
      </div>
    </InvestmentGraphic>
  );
};

export default LoanProfitChart;
